import classNames from 'classnames';
import Label from 'components/Label/Label';
import MarketplacesDropdown from 'components/MarketplacesDropdown/MarketplacesDropdown';
import { useMarketplaces } from 'hooks/redux/useMarketplaces';
import './marketplace-filter.scss';

export default function MarketplaceFilter({
  currentMarketplace,
  clearable = true,
  inline = false,
  onChangeMarketplace = () => {},
}) {
  const { marketplaces } = useMarketplaces();

  return (
    <div
      className={classNames('marketplace-filter', {
        'marketplace-filter--inline': inline,
      })}
    >
      <Label small className="marketplace-filter__label">
        Marketplace
      </Label>
      <MarketplacesDropdown
        marketplaces={marketplaces}
        clearable={clearable}
        multiple={false}
        className="marketplace-filter__dropdown"
        value={currentMarketplace || null}
        onChange={onChangeMarketplace}
      />
    </div>
  );
}
